var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "estate-comment"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('el-input', {
    staticClass: "f-search-bar",
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "placeholder": "问题关键词、发布者昵称"
    },
    model: {
      value: _vm.queryData.title,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "title", $$v);
      },
      expression: "queryData.title"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1)], 1), _c('el-table', {
    staticClass: "body",
    attrs: {
      "border": "",
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "提问内容",
      "prop": "content"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c('div', {
          staticClass: "title",
          domProps: {
            "innerHTML": _vm._s(row.content.replace(/\n/g, '<br>'))
          }
        })];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "渠道来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [row.terminalSource == 4 ? [_c('div', {
          staticClass: "title"
        }, [_vm._v("房猫CMS")]), _c('p', [_vm._v("WEB端")])] : [_c('div', {
          staticClass: "title"
        }, [_vm._v(" " + _vm._s(row.platformName || "-") + " ")]), _c('p', [_vm._v(_vm._s(_vm.terminalSourceMaps[row.terminalSource] || "-"))])]];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "发布者"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return [_c('div', {
          staticClass: "title"
        }, [_vm._v(_vm._s(row.customerName))]), row.authSlaveType ? _c('p', [_vm._v(" " + _vm._s(_vm.authSlaveTypeMaps[row.authSlaveType].label) + " ")]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "提问时间",
      "prop": "inDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var row = _ref4.row;
        return [_c('div', {
          staticClass: "title"
        }, [_vm._v(_vm._s(row.inDate))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var row = _ref5.row;
        return [_c('el-popover', {
          ref: "popover".concat(row.trendsId),
          attrs: {
            "placement": "top-end",
            "width": "365"
          },
          model: {
            value: row.showDiscuss,
            callback: function callback($$v) {
              _vm.$set(row, "showDiscuss", $$v);
            },
            expression: "row.showDiscuss"
          }
        }, [_c('discuss', {
          attrs: {
            "count": row.commentCount,
            "bizId": row.trendsId,
            "show": row.showDiscuss,
            "commentType": 4
          },
          on: {
            "refresh": _vm.getList
          }
        })], 1), row.commentCount ? _c('el-button', {
          directives: [{
            name: "popover",
            rawName: "v-popover:[`popover${row.trendsId}`]",
            arg: "popover".concat(row.trendsId)
          }],
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_vm._v("讨论(" + _vm._s(row.commentCount) + ") ")]) : _vm._e(), row.commentCount ? _c('span', {
          staticClass: "separate"
        }, [_vm._v("|")]) : _vm._e(), _c('el-popconfirm', {
          attrs: {
            "title": "确定删除该评论？"
          },
          on: {
            "onConfirm": function onConfirm($event) {
              return _vm.deleteTrends(row.trendsId);
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_vm._v("删除")])], 1)];
      }
    }])
  })], 1), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryData.pageNum,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryData.pageSize,
      "layout": "sizes, prev, pager, next,jumper",
      "total": _vm.commentTotal
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageNumChange,
      "update:currentPage": function updateCurrentPage($event) {
        return _vm.$set(_vm.queryData, "pageNum", $event);
      },
      "update:current-page": function updateCurrentPage($event) {
        return _vm.$set(_vm.queryData, "pageNum", $event);
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }